var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history-section" },
    [
      _c("div", { staticClass: "modal-body-title" }, [
        _vm._v(_vm._s(_vm.history.userName))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body-time" }, [
        _vm._v(_vm._s(_vm._f("formatLastUpdate")(_vm.history.timeModified)))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-body-collapse-btn",
          on: {
            click: function($event) {
              _vm.isExpanded = !_vm.isExpanded
            }
          }
        },
        [
          _vm.isExpanded
            ? _c("Icon", {
                staticClass: "event-icon",
                attrs: { name: "chevron-right" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isExpanded
            ? _c("Icon", {
                staticClass: "event-icon",
                attrs: { name: "chevron-down" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.history.fieldsChangeCount) + " changes")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isExpanded
          ? _c("div", [
              _c(
                "div",
                { staticClass: "modal-body-table" },
                [
                  _c("b-table", {
                    staticClass: "modal-table",
                    attrs: {
                      striped: "",
                      outlined: "",
                      small: "",
                      bordered: "",
                      hover: "",
                      items: _vm.history.items
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body-comments" }, [
                _vm._v(_vm._s(_vm.history.additionalComment))
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12c26260", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c26260","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/HistoryModalSection.vue
// module id = 1456
// module chunks = 1